import EndpointNumber from "../EndpointNumber";
import {useParams} from "react-router";

export default function PersonalExtension() {
    const {extensionId} = useParams();
    return <EndpointNumber id={parseInt(extensionId)} type="users" />;
}
